
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reading-goal",
      function () {
        return require("private-next-pages/reading-goal/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reading-goal"])
      });
    }
  